import { type IconName } from 'core/ui/components/icon/Icon'
import { plural } from 'core/utils/string'

import { phoneNumber } from 'legacy/utils/phoneNumber'

import { type Facility } from '../domain/Facility'

export function formatScoreNumber(score: number) {
  return `${score.toFixed(1)}`
}

export function formatReviewCount(count: number, inline: boolean = false) {
  if (inline) return `(${count} ${plural('Review', count)})`
  return `${count} ${plural('Review', count)}`
}

export function getScorePercentage(total: number, count = 0) {
  if (count === 0) return 0

  return (100 * count) / total
}

export function formatFacilityTraitText(value: number, positive?: boolean) {
  const kind = positive ? 'positive' : 'negative'
  return {
    kindText: `of ${kind} reviews`,
    percentageText: `${value.toFixed(0)}% `,
  }
}

export function formatName(facility: Facility) {
  const { companyName, address } = facility
  return companyName || address
}

export function formatContact(
  facility: Facility
): { icon: IconName; value: string; link: string } | undefined {
  const { contact } = facility

  if (!contact) return undefined

  if (contact.phoneNumber) {
    return {
      icon: 'phone',
      value: phoneNumber.format(contact.phoneNumber, '+X (XXX) XXX-XXXX'),
      link: `tel:${contact.phoneNumber}`,
    }
  }

  return {
    icon: 'email-filled',
    value: contact.email,
    link: `mailto:${contact.email}`,
  }
}

export function formatFacilityAddress({
  address,
  city,
  state,
  zipcode,
}: {
  address?: string
  city: string
  state: string
  zipcode: string
}) {
  const location = `${city}, ${state} - ${zipcode}`
  return address ? `${address}, ${location}` : location
}
